import { render, staticRenderFns } from "./ItemBirthday.vue?vue&type=template&id=47430ea3&"
import script from "./ItemBirthday.vue?vue&type=script&lang=js&"
export * from "./ItemBirthday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports